
import { toPairs } from 'ramda'

import type { PostParams, Dish } from 'app/dataTypes/dishes/dish'

import type { Request } from '../../index'
import { ApiResultItem, convertDishItem } from './get'

/**
 * Создание / редактирование блюда
 */

type ApiParams = {
  id?: number // только при редактировании
  title: string
  photo?: {
    file: string
    o?: number
    w: number
    x1: number
    y1: number
    x2: number
    y2: number
  },
  portion?: string
  cost: number
  sale_type_id: number
}

export const convertParams = (params: PostParams): [ApiParams, null] => {
  const { id, title, photo, portion, cost, saleTypeId, nomenclature } = params
  return [{
    ...(id ? { id: parseInt(id, 10) } : {}),
    title,
    ...(photo ? { photo } : {}),
    ...(portion ? { portion } : {}),
    cost: parseFloat(cost),
    sale_type_id: parseInt(saleTypeId, 10),
    ...(nomenclature ? { nomenclature } : {}),
  }, null]
}

type ApiResult = Record<string, ApiResultItem>

export const convertResult = (data: ApiResult): Dish => {
  const [[, value]] = toPairs(data)
  return convertDishItem(value)
}

export const POST_FOOD_ITEMS: Request<PostParams, Dish, void> = [
  'food/items',
  'post',
  ['data', 'items'],
]
